// i18n/es.js
// PrizeReal — Textos en español (LATAM)
// Fuente de verdad para todos los strings visibles en la UI.
// Nunca poner texto hardcodeado en componentes o pantallas.

const es = {

  // ─── General ───────────────────────────────────────────────────────────────
  app: {
    name:    "PrizeReal",
    tagline: "Compartí local. Aparecé en persona. Ganate tu premio.",
    loading: "Cargando...",
    error:   "Algo salió mal. Intentá de nuevo.",
    retry:   "Reintentar",
    save:    "Guardar",
    cancel:  "Cancelar",
    confirm: "Confirmar",
    close:   "Cerrar",
    back:    "Volver",
    next:    "Siguiente",
    done:    "Listo",
    yes:     "Sí",
    no:      "No",
  },

  // ─── Auth ──────────────────────────────────────────────────────────────────
  auth: {
    welcomeTitle:    "Bienvenido a PrizeReal",
    welcomeSubtitle: "Ingresá para empezar a ganar premios en locales cercanos.",
    signInGoogle:    "Ingresar con Google",
    signInLoading:   "Ingresando...",
    signOutButton:   "Cerrar sesión",
    signOutConfirm:  "¿Querés cerrar sesión?",

    // Verificación SMS
    smsTitle:        "Verificá tu número",
    smsSubtitle:     "Te enviamos un código al {phone}. Ingresalo para continuar.",
    smsPlaceholder:  "Tu número de teléfono",
    smsCodeLabel:    "Código de verificación",
    smsCodePlaceholder: "6 dígitos",
    smsSend:         "Enviar código",
    smsVerify:       "Verificar",
    smsResend:       "Reenviar código",
    smsResendIn:     "Reenviar en {seconds}s",
    smsSuccess:      "Número verificado ✓",
    smsError:        "Código incorrecto. Intentá de nuevo.",
    smsRequired:     "Necesitás verificar tu número para canjear premios.",

    errors: {
      googleFailed:  "No se pudo ingresar con Google. Intentá de nuevo.",
      phoneFailed:   "No se pudo enviar el código. Verificá el número.",
      codeFailed:    "Código incorrecto o expirado.",
      networkError:  "Sin conexión. Revisá tu internet.",
    },
  },

  // ─── Home ──────────────────────────────────────────────────────────────────
  home: {
    title:           "Locales cerca tuyo",
    subtitle:        "Compartí, aparecé en persona y ganá.",
    searchPlaceholder: "Buscar local...",
    filterAll:       "Todos",
    noResults:       "No encontramos locales en tu zona.",
    noResultsHint:   "Intentá con otra búsqueda o revisá más tarde.",
    distanceUnit:    "m",
    distanceUnitKm:  "km",
    featured:        "Destacado",
    closedToday:     "Cerrado hoy",
    clicksNeeded:    "{n} clicks para canjear",
    clicksOne:       "1 click para canjear",
  },

  // ─── Tarjeta de comercio ───────────────────────────────────────────────────
  bizCard: {
    shareButton:     "Compartir",
    claimButton:     "Canjear",
    prize:           "Premio: {prize}",
    friendPrize:     "Tus amigos reciben: {prize}",
    clicksProgress:  "{current}/{needed} clicks",
    planBadge:       "{plan}",
  },

  // ─── Share ─────────────────────────────────────────────────────────────────
  share: {
    title:           "Compartí {business}",
    subtitle:        "Mandales este link a tus contactos. Cada click cuenta.",
    linkCopied:      "¡Link copiado!",
    copyLink:        "Copiar link",
    shareWhatsApp:   "Compartir por WhatsApp",
    shareEmail:      "Compartir por Email",
    shareOther:      "Otras opciones",
    clickCount:      "{n} clicks recibidos",
    clickCountOne:   "1 click recibido",
    clickCountZero:  "Todavía sin clicks",
    prize:           "Tu premio al llegar: {prize}",
    friendPrize:     "Tus amigos reciben: {prize}",
    howItWorks:      "¿Cómo funciona?",
    step1:           "Compartís el link",
    step2:           "Tus amigos lo abren",
    step3:           "Vas al local y escaneás el QR",
    step4:           "¡Recibís tu premio!",

    // Mensaje pre-armado para WhatsApp/Email
    whatsappMessage: "¡Mirá este local! Abrí el link y yo gano un premio — y vos también tenés un descuento en tu primera visita 👉 {url}",
    emailSubject:    "Te recomiendo este local — y los dos ganamos",
    emailBody:       "Hola! Te comparto este local que me parece bueno. Si abrís el link, yo puedo canjear un premio — y vos también tenés un descuento en tu primera visita.\n\n{url}\n\n¡Nos vemos!",
  },

  // ─── Claim (Canje) ─────────────────────────────────────────────────────────
  claim: {
    title:           "Canjeá tu premio",
    subtitle:        "Escaneá el QR del local para confirmar tu presencia.",
    scanButton:      "Escanear QR",
    scanInstructions:"Apuntá la cámara al código QR del local.",
    scanSuccess:     "¡QR válido!",
    verifying:       "Verificando...",
    locationRequired:"Necesitamos tu ubicación para confirmar que estás en el local.",
    locationGranted: "Ubicación confirmada ✓",
    locationDenied:  "Activá tu GPS para poder canjear.",
    tooFarAway:      "Estás a {distance}m del local. Necesitás estar a menos de 300m.",
    qrExpired:       "El QR expiró. Pedile al local que muestre uno nuevo.",
    qrInvalid:       "QR no reconocido. Asegurate de escanear el QR de PrizeReal.",
    mockLocation:    "Detectamos una ubicación simulada. Por favor desactivá cualquier app de GPS falso.",
    notEnoughClicks: "Necesitás {needed} clicks para canjear. Tenés {current}.",
    alreadyClaimed:  "Ya canjeaste este premio. Podés volver a intentarlo en {days} días.",
    rateLimited:     "Alcanzaste el límite diario de canjes. Intentá mañana.",

    errors: {
      cameraPermission: "Necesitamos acceso a la cámara para escanear el QR.",
      networkError:     "Sin conexión. El canje no se pudo registrar.",
      serverError:      "Error del servidor. Intentá de nuevo.",
    },
  },

  // ─── Success ───────────────────────────────────────────────────────────────
  success: {
    title:           "¡Premio canjeado!",
    subtitle:        "Mostrá esta pantalla en el local.",
    prize:           "{prize}",
    businessName:    "en {business}",
    timestamp:       "Canjeado el {date} a las {time}",
    ratingTitle:     "¿Cómo fue la experiencia?",
    ratingSubtitle:  "Tu opinión ayuda a otros usuarios.",
    ratingLabel:     "Calificá a {business}",
    ratingSubmit:    "Enviar calificación",
    ratingThanks:    "¡Gracias por calificar!",
    reportProblem:   "Reportar un problema",
    backHome:        "Volver al inicio",
    shareAgain:      "Compartir de nuevo",
  },

  // ─── Levels ────────────────────────────────────────────────────────────────
  levels: {
    title:           "Tu nivel",
    totalClicks:     "{n} clicks totales",
    currentLevel:    "Nivel actual",
    nextLevel:       "Próximo nivel",
    clicksToNext:    "Te faltan {n} clicks para {level}",
    atMaxLevel:      "¡Llegaste al nivel máximo!",
    leaderboardTitle:"Top de la ciudad",
    leaderboardEmpty:"Todavía no hay datos. ¡Sé el primero!",
    rank:            "#{n}",
    you:             "(vos)",
    perks:           "Beneficios",
    perkDescriptions: {
      standard_prizes:  "Premios estándar en todos los locales",
      plus_10_percent:  "+10% en todos los premios",
      vip_offers:       "Ofertas VIP exclusivas",
      early_access:     "Acceso anticipado a nuevas ofertas",
      top_leaderboard:  "Top del leaderboard de la ciudad",
      exclusive_prizes: "Premios exclusivos City Legend",
    },
  },

  // ─── Plans (para comercios) ────────────────────────────────────────────────
  plans: {
    title:           "Planes para tu local",
    subtitle:        "Sin costo de instalación. Sin contratos de largo plazo.",
    perMonth:        "/mes",
    free:            "Gratis",
    mostPopular:     "Más popular",
    currentPlan:     "Plan actual",
    upgrade:         "Mejorar plan",
    downgrade:       "Cambiar plan",
    cancel:          "Cancelar suscripción",
    cancelConfirm:   "¿Seguro que querés cancelar? Perderás tu plan al final del período.",
    earlyPartner:    "3 meses gratis para primeros partners",
  },

  // ─── Dispute ───────────────────────────────────────────────────────────────
  dispute: {
    title:           "Reportar un problema",
    subtitle:        "Describí qué pasó. Nuestro equipo lo revisa en 48 horas.",
    typeLabel:       "Tipo de problema",
    types: {
      prize_not_given:   "El local no me dio el premio",
      qr_not_working:    "El QR no funcionaba",
      wrong_prize:       "El premio fue diferente al prometido",
      location_error:    "Error de ubicación",
      other:             "Otro",
    },
    descriptionLabel:    "Descripción",
    descriptionPlaceholder: "Contanos qué pasó con el mayor detalle posible.",
    submit:              "Enviar reporte",
    submitSuccess:       "Reporte enviado. Te contactamos en menos de 48 horas.",
    submitError:         "No se pudo enviar el reporte. Intentá de nuevo.",
    slaNote:             "Tiempo de respuesta: máximo 48 horas.",
  },

  // ─── Navbar ────────────────────────────────────────────────────────────────
  nav: {
    home:    "Inicio",
    levels:  "Niveles",
    profile: "Perfil",
  },

  // ─── Errores genéricos ─────────────────────────────────────────────────────
  errors: {
    notFound:       "Página no encontrada.",
    unauthorized:   "Necesitás iniciar sesión.",
    offline:        "Sin conexión a internet.",
    generic:        "Ocurrió un error inesperado.",
    tryAgain:       "Intentá de nuevo",
  },
};

export default es;
